import { ConfigurationService } from './core/configuration/configuration.service';

export function localeIdFactory() {
  return (configuration: ConfigurationService): string => {
    return configuration.locale;
  };
}


